module.exports = __webpack_public_path__ + "media/images/projects/14-logo-4942bcb2ecd3209312366d6bfebab0a1.png";